import { ApiClient } from 'gain-web/shared-services/api-client.generated.service';

export function getDisplayNameOrDefault(
  details: ApiClient.EnumValueDisplayDetails,
) {
  return details.displayName ?? details.name;
}

export function getShortDisplayNameOrDefault(
  details: ApiClient.EnumValueDisplayDetails,
) {
  return details.shortDisplayName ?? details.name;
}
